var _rect, _ellipse, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiLgDiscussion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 61 30",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 1,
    width: 18,
    height: 19,
    rx: 1,
    fill: "#A8FFF8"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25,
    cy: 22.5,
    rx: 9,
    ry: 6.5,
    fill: "#CBFF88"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.563 11.375H34v10.219h-6.738L21.488 25v-3.832h-1.925v-9.793z",
    fill: "#14454C",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.077 4.928c0-.236.198-.428.442-.428h15.039a.45.45 0 01.313.125.42.42 0 01.129.303v11.978a.435.435 0 01-.442.428h-2.212v2.994c0 .158-.09.303-.233.377a.455.455 0 01-.455-.021l-5.196-3.35H25.52a.45.45 0 01-.313-.126.42.42 0 01-.13-.302l.001-11.978zm.885.428v11.122h6.634c.087 0 .173.025.246.072l4.62 2.979v-2.623a.42.42 0 01.129-.303.45.45 0 01.313-.125h2.211V5.356H25.962z",
    fill: "#14454C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.904 8.778c.244 0 .442.191.442.428a.435.435 0 01-.442.427h-9.73a.435.435 0 01-.443-.427c0-.237.198-.428.442-.428h9.73zM37.904 13.056c.244 0 .442.191.442.427a.435.435 0 01-.442.428h-9.73a.435.435 0 01-.443-.428c0-.236.198-.427.442-.427h9.73zM19.442 10.528a.435.435 0 00-.442.428V21.65c0 .236.198.428.442.428h2.212v2.994c0 .161.093.308.242.381.148.073.326.06.46-.035l4.749-3.34h6.491a.435.435 0 00.442-.428.435.435 0 00-.442-.428h-6.634a.452.452 0 00-.26.082l-4.164 2.928V21.65a.435.435 0 00-.442-.428h-2.211v-9.839h3.096a.435.435 0 00.442-.427.435.435 0 00-.442-.428h-3.539z",
    fill: "#14454C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 6l.99 2.51L54 9.5l-2.51.99L50.5 13l-.99-2.51L47 9.5l2.51-.99L50.5 6zM59 17l.566 1.434L61 19l-1.434.566L59 21l-.566-1.434L57 19l1.434-.566L59 17zM9.5 21l.99 2.51 2.51.99-2.51.99L9.5 28l-.99-2.51L6 24.5l2.51-.99L9.5 21zM2 16l.566 1.434L4 18l-1.434.566L2 20l-.566-1.434L0 18l1.434-.566L2 16z",
    fill: "#14D1C2"
  })));
}
export default __webpack_public_path__ + "fonts/ai-lg-discussion-2daad4615a9c120e68f62fa48da35d79.svg";
export { SvgAiLgDiscussion as ReactComponent };